import { useState } from "react";
import { GoogleGenerativeAI } from "@google/generative-ai";

const API_KEY = "AIzaSyA80z4HmP4VNmW1O0n-tCRJhwhEwDzK6NU";
const MODEL = "gemini-2.5-flash";

const genAI = new GoogleGenerativeAI(API_KEY);

function buildPrompt(instruction, input) {
  return `
Instructions:
${instruction}
Input:
${input}
`;
}

export async function askGemini(instruction, input) {
  try {
    const model = genAI.getGenerativeModel({
      model: MODEL,
    });

    const prompt = buildPrompt(instruction, input);

    const result = await model.generateContent(prompt);

    const response = await result.response;
    console.log(response.text());
    return response.text();
  } catch (error) {
    console.error(error);
    return "Error while fetching response";
  }
}
